import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../../../core/services/auth.service';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';
import { Subscription } from 'rxjs/Rx';
import * as intlTelInput from 'intl-tel-input';
import { UserDAO } from '../../../../core/services/dao/userDAO';
import * as moment from 'moment';
import { Moment } from 'moment';
import { AppMessagingService } from '../../../../core/services/app-messaging.service';
import { NameCheckReturn } from '../../enrollEmailDuplicate/enroll-email-duplicate.directive';
import { Router } from '@angular/router';

@Component({
  selector: 'app-buyflow-request-login-dialog',
  templateUrl: './buyflow-request-login-dialog.component.html',
  styleUrls: ['./buyflow-request-login-dialog.component.scss'],
})
export class BuyflowRequestLoginDialogComponent
  implements OnInit, OnDestroy, ContainsSubscriptions, AfterViewInit
{
  model: any = {
    email: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    birthday: '',
    password: '',
  };
  @ViewChild('intlTelInput') private _inputElement!: ElementRef;
  private _intlTelInput: any;

  @ViewChild('intlTelVerifyInput') private _inputElementVerify!: ElementRef;
  private _intlTelVerifyInput: any;
  public E164PhoneNumber!: string | null;

  isSignup = false;
  subs: Subscription[] = [];
  birthMonth: number;
  birthDay: number;
  birthYear: number;
  currentYear: number;
  isFbUser = false;
  isGoogleUser = false;
  resetEmailSent = false;
  maxSignupDate: Moment;
  maxSignupyear: number;
  showPhoneVerification = false;
  phoneCodeSent = false;
  phoneCodeError = '';
  phoneCodeSuccess = false;
  phoneCode = '';
  newUserId: number;
  emailTaken = false;
  changePhoneNumber = false;
  passwordExpired: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<BuyflowRequestLoginDialogComponent>,
    private authService: AuthService,
    private userDAO: UserDAO,
    private appMessagingService: AppMessagingService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.maxSignupDate = moment().subtract(18, 'years').add(1, 'day');
    this.maxSignupyear = this.maxSignupDate.get('year');
    console.log(this.router.url);
    if (this.data.userEmail) {
      this.model.email = this.data.userEmail;
    }
    this.currentYear = new Date().getFullYear();
    if (!this.data.oAuthProvider) {
      this.showSignupOrLogin();
    } else {
      if (this.data.oAuthProvider === 'facebook') {
        this.isFbUser = true;
      } else if (this.data.oAuthProvider === 'google') {
        this.isGoogleUser = true;
      }
    }
  }

  ngAfterViewInit(): void {
    const intlTelInputInstance = intlTelInput;
    setTimeout(() => {
      if (this._inputElement) {
        this._intlTelInput = intlTelInputInstance(
          this._inputElement.nativeElement,
          { preferredCountries: ['us', 'mx'] },
        );
      }
    }, 1000);
  }

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }

  showSignupOrLogin() {
    // if user is social user, or email does not exist then show sign up
    const authSub = this.authService
      .checkUserSocialStatus(this.data.userEmail)
      .subscribe((userInfo) => {
        console.log(userInfo);
        if (userInfo.userExists) {
          console.log(userInfo);
          if (!userInfo.hasPassword && userInfo.isSocialUser) {
            this.isSignup = true;
          } else if (userInfo.isSocialUser && !userInfo.hasPassword) {
            if (userInfo.fb) {
              this.isFbUser = true;
            } else if (userInfo.goog) {
              this.isGoogleUser = true;
            }
          } else if (userInfo.resetPassword) {
            this.passwordExpired = true;
          }
        } else {
          this.isSignup = true;
        }
      });
    this.subs.push(authSub);
  }

  loginOrSignupClick() {
    if (this.isSignup) {
      this.createAccountClick();
    } else {
      const loginSub = this.authService
        .login(this.model.email, this.model.password)
        .subscribe((isLoggedIn) => {
          if (isLoggedIn) {
            this.dialogRef.close(isLoggedIn);
          } else {
          }
        });
      this.subs.push(loginSub);
    }
  }

  createAccountClick() {
    const dob = new Date(this.birthYear, this.birthMonth, this.birthDay);
    const emailUser = {
      birthday: dob.toISOString(),
      firstName: this.model.firstName,
      lastName: this.model.lastName,
      password: this.model.password,
      email: this.model.email,
      username: this.model.email,
      phoneNumber: this.model.phoneNumber,
    };

    const createSub = this.userDAO
      .createEmailAccountForNewCustomer(emailUser)
      .subscribe((createUserRes) => {
        const authSub = this.authService
          .login(this.model.email, this.model.password)
          .subscribe(
            (user: any) => {
              if (user) {
                this.newUserId = createUserRes.id;
                this.showPhoneVerification = true;
                this.sendVerification();
              }
            },
            (error1) => {
              console.error(error1);
            },
          );
        this.subs.push(authSub);
      });
    this.subs.push(createSub);
  }

  hasValidPhoneNumber(): boolean {
    if (this._intlTelInput && this._intlTelInput.isValidNumber()) {
      return true;
    }
    return false;
  }

  sendVerification(): void {
    if (this.hasValidPhoneNumber()) {
      const sub = this.userDAO
        .sendSmsForPhoneVerification(this.newUserId, this.E164PhoneNumber)
        .subscribe((sentVerificationResult) => {
          this.appMessagingService.openSnack(
            'Phone verification code sent successfully',
          );
          console.log('sent successfully');
          this.phoneCodeSent = true;
        });
      this.subs.push(sub);
    }
  }

  showHidePassword() {
    let button = document.getElementById('showHideButton');
    let passwordInput = document.getElementById('passwordInput');
    if (passwordInput.getAttribute('type') === 'password') {
      passwordInput.setAttribute('type', 'text');
      button.innerText = 'Hide';
    } else {
      passwordInput.setAttribute('type', 'password');
      button.innerText = 'Show';
    }
  }

  disableForSignup(): boolean {
    if (this.isSignup) {
      let date = moment(
        `${this.birthYear}-${this.birthMonth}-${this.birthDay}`,
        'YYYY-MM-DD',
      );
      return !(
        this.model.email &&
        this.model.phoneNumber &&
        this.hasValidPhoneNumber() &&
        this.model.firstName &&
        this.model.lastName &&
        this.model.password &&
        this.model.password.length >= 8 &&
        date.isValid() &&
        date.isSameOrBefore(this.maxSignupDate) &&
        !this.emailTaken
      );
    } else {
      return false;
    }
  }

  sendForgotPassword() {
    let resetUrl = window.location.origin + '/users/reset-password';

    const currentUrl = this.router.url;

    const submitEmailSub = this.userDAO
      .requestEmail(this.model.email, resetUrl, currentUrl)
      .subscribe((res) => {
        this.resetEmailSent = true;
      });
    this.subs.push(submitEmailSub);
  }

  closeDialog() {
    this.dialogRef.close(false);
  }

  get intlTelInput(): any {
    return this._intlTelInput;
  }

  get internationalPhoneNumber(): string {
    return this.model.phoneNumber;
  }

  set internationalPhoneNumber(value: string) {
    if (this._intlTelInput) {
      if (!!value) {
        this._intlTelInput.setNumber(value);
      }
      this.model.phoneNumber = value;
      this.i18nizePhoneNumber();
    }
  }

  public i18nizePhoneNumber(): void {
    this.E164PhoneNumber = null;
    if (this._intlTelInput.isValidNumber()) {
      this.E164PhoneNumber = this._intlTelInput.getNumber();
    }
  }

  confirmPhoneCode(): void {
    const sub = this.userDAO
      .smsConfirmPhone(this.phoneCode, this.newUserId)
      .subscribe((phoneConfirmed) => {
        if (phoneConfirmed.success) {
          this.phoneCodeSuccess = true;
          this.dialogRef.close();
        } else {
          console.log('phone code confirmation failed');
          this.phoneCodeError =
            'Failed to verify phone number, please try again';
        }
      });
    this.subs.push(sub);
  }

  emailBlurred(emailString: string) {
    this.userDAO.checkEmail<NameCheckReturn>(emailString).subscribe((res) => {
      if (this.isSignup) {
        this.emailTaken = res.emailDuplicate;
      }
    });
  }

  toggleNumberChange() {
    this.changePhoneNumber = !this.changePhoneNumber;
    const intlTelInputInstance = intlTelInput;
    setTimeout(() => {
      if (this._inputElementVerify) {
        this._inputElementVerify = intlTelInputInstance(
          this._inputElementVerify.nativeElement,
          { preferredCountries: ['us', 'mx'] },
        );
      }
    }, 1000);
  }

  resend() {
    this.userDAO.requestPhoneVerify().subscribe((result) => {
      console.log(result);
    });
  }

  update() {
    if (this.model.phoneNumber.includes('_')) {
      console.log('invalid number');
      return;
    }
    const phoneSubscription = this.userDAO
      .updateUser(this.model)
      .subscribe((response: any) => {
        this.resend();
        this.changePhoneNumber = false;
      });
    this.subs.push(phoneSubscription);
  }
}
